import { franc } from 'franc';

const SUPPORTED_LANGUAGES = ['nld', 'eng'] as const;

export function detectLanguage(text: string = ''): 'nl' | 'en' {
  // First try to get browser language
  const browserLang = getBrowserLanguage();
  if (text.length < 10) return browserLang;
  
  // If there's enough text, detect the language
  const detectedLang = franc(text, {
    only: Array.from(SUPPORTED_LANGUAGES),
    minLength: 1
  });
  
  return detectedLang === 'nld' ? 'nl' : 'en';
}

export function getBrowserLanguage(): 'nl' | 'en' {
  const lang = navigator.language.toLowerCase();
  return lang.startsWith('nl') ? 'nl' : 'en';
}

export const greetings = {
  nl: [
    'Hallo! Ik ben Julia. Hoe kan ik u vandaag helpen?',
    'Welkom! Waarmee kan ik u van dienst zijn?',
    'Goedendag! Waar kan ik u mee helpen?'
  ],
  en: [
    'Hi! I\'m Julia. How can I help you today?',
    'Welcome! How may I assist you?',
    'Hello! What can I help you with?'
  ]
};

export function getRandomGreeting(language: 'nl' | 'en'): string {
  const greetingList = greetings[language];
  const randomIndex = Math.floor(Math.random() * greetingList.length);
  return greetingList[randomIndex];
}